import { Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { isEmpty } from 'lodash'
import React, { useEffect } from 'react'

import { useSubscriptionDetails } from '../../hooks/subscriptions'
import { pushAnalyticsEvent } from '../../util/gtmUtils'
import HomeReferral from './HomeReferral'
import HomeSubscription from './HomeSubscription'

const HomeSidebar = ({ showSubscription }) => {
  const { subscriptionDetails, subscriptionEligible } = useSubscriptionDetails()
  const isEligible = // Specific to promotional. Not a subscription.
    (isEmpty(subscriptionDetails) || subscriptionDetails?.status === 'UNSUBSCRIBED') && // Haven't had a prev subscription, or is unsubscribed
    subscriptionEligible

  useEffect(() => {
    if (isEligible) {
      pushAnalyticsEvent('Subscriptions', 'Promo Card - View')
    }
  }, [isEligible])

  if (subscriptionEligible === undefined) return <SkeletonLoadingHomeSidebar />

  return (
    <Box marginTop={4}>
      {isEligible && showSubscription ? (
        <HomeSubscription isSubscribedBefore={Boolean(subscriptionDetails)} />
      ) : (
        <HomeReferral />
      )}
    </Box>
  )
}

export const SkeletonLoadingHomeSidebar = () => (
  <Box marginTop={5}>
    <Box marginBottom={2}>
      <Skeleton height={240} variant="rect" width={200} />
    </Box>
    <Skeleton height={40} width={150} />
    <Skeleton width={210} />
    <Skeleton width={210} />
    <Skeleton height={70} width={150} />
  </Box>
)

export default HomeSidebar
